// import wappage from "@/components/_WAP/games/Fantasy";
import pcpage from "@/components/game/Legend";
import { loadPage } from "@/components/_WAP/js/base";

loadPage(pcpage);
